/* (ignored) */


//////////////////
// WEBPACK FOOTER
// intl/locale-data/complete.js (ignored)
// module id = 3
// module chunks = polyfills